import { render, staticRenderFns } from "./ScopesNotice.vue?vue&type=template&id=b85fe324&"
import script from "./ScopesNotice.vue?vue&type=script&lang=ts&"
export * from "./ScopesNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports